import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("ConfiguracaoMenuFilter")
export class ConfiguracaoMenuFilter {

  idMunicipio: number;
}
